import type { ComponentProps } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";

import { isUnifiedPositionEnabled } from "app/components/campaigns/shared/utils";
import type SwPageContent from "app/components/page-content";
import { useKeywordsCampaignsContext } from "app/pages/digital-marketing/keywords-campaigns/infra/KeywordsCampaignsContext";
import { useCollectingCampaignPoll } from "app/pages/digital-marketing/keywords-campaigns/shared/hooks/useCollectingCampaignPoll";
import { useIsCampaignCollecting } from "app/pages/digital-marketing/keywords-campaigns/shared/hooks/useIsCampaignCollecting";

import { DataCollectionInProgressBanner } from "./DataCollectionInProgressBanner";
import { PositionAnnouncementBanner } from "./PositionAnnouncementBanner/PositionAnnouncementBanner";
import { RankTrackerPageContentWrapper } from "./styles";

export const RankTrackerPageContent = ({ children, ...rest }: ComponentProps<typeof SwPageContent>) => {
    const isCollecting = useIsCampaignCollecting();
    const { demoCampaigns } = useKeywordsCampaignsContext();
    const { params } = useCurrentStateAndParams();
    const { campaignId } = params;
    const isDemoCampaign = demoCampaigns.some((campaign) => campaign.id === campaignId);

    useCollectingCampaignPoll();

    const showPositionAnnouncementBanner = !isUnifiedPositionEnabled() && !isDemoCampaign && !isCollecting;

    return (
        <RankTrackerPageContentWrapper {...rest}>
            {showPositionAnnouncementBanner ? <PositionAnnouncementBanner /> : null}
            {isCollecting ? <DataCollectionInProgressBanner /> : null}
            {children}
        </RankTrackerPageContentWrapper>
    );
};
